import { z } from "zod";

export const fuelSlotRequestOrderCreationSchema = z.object({
  orders: z
    .array(
      z.object({
        dispatchPlace: z.any().optional(),
        observations: z.string().optional(),
        URLMaps: z.string().optional(),
        products: z
          .array(
            z.object({
              productId: z.any().optional(),
              tons: z.any().optional(),
            }),
          )
          .optional(),
      }),
    )
    .optional(),
});

export type FuelSlotRequestOrderCreationForm = z.infer<
  typeof fuelSlotRequestOrderCreationSchema
>;
